import type { FandomContext } from "common-types";

export function getFandomContext(): FandomContext | null {
  return window.fandomContext ?? null;
}
